import {get} from '../utils'

export default host => id =>
  get(`${host}/users/${id}?include=image;role;contentCreator`)
  .then(response => response.json())
  .then(json => json.data)